import React, { useState, useEffect } from 'react';
import styles from './Tasks.module.css';
import useWalletStore from '../../providers/walletStore';
import { useSupabaseStore } from '../../providers/supabaseStore';
import useReward from '../../hooks/useReward';

const Tasks = () => {
  const { claimDailyCheckIn } = useReward();
  const { fetchPoints, checkDailyStatus, hasCheckedInToday } = useSupabaseStore();
  const { wallet } = useWalletStore();
  const [dailyCheckInCompleted, setDailyCheckInCompleted] = useState(false);

  useEffect(() => {
    if (wallet?.address) {
      checkDailyStatus(wallet.address);
    }
  }, [wallet?.address, checkDailyStatus]);

  // Update local state when store state changes
  useEffect(() => {
    setDailyCheckInCompleted(hasCheckedInToday);
  }, [hasCheckedInToday]);

  const dailyTasks = [
    {
      id: 'daily-1',
      title: 'Daily Check-in',
      points: 50,
      status: dailyCheckInCompleted ? 'completed' : 'incomplete',
      icon: '📅'
    }
  ];

  const socialTasks = [
    {
      id: 'social-1',
      title: 'Follow on Twitter',
      points: 50,
      status: 'incomplete',
      icon: '🐦'
    },
    {
      id: 'social-2',
      title: 'Join Discord',
      points: 50,
      status: 'incomplete',
      icon: '💬'
    },
    {
      id: 'social-3',
      title: 'Share a Tweet',
      points: 100,
      status: 'incomplete',
      icon: '📢'
    }
  ];

  const handleTaskClick = async (taskId) => {
    if (taskId === 'daily-1' && !dailyCheckInCompleted) {
      try {
        const success = await claimDailyCheckIn();
        if (success) {
          setDailyCheckInCompleted(true);
          // Refresh points after claiming
          if (wallet?.address) {
            fetchPoints(wallet.address);
          }
        }
      } catch (error) {
        console.error('Failed to claim daily check-in:', error);
      }
    }
  };

  const TaskList = ({ tasks, title, disabled = false }) => (
    <div className={`${styles.taskCategory} ${disabled ? styles.disabled : ''}`}>
      <div className={styles.categoryHeader}>
        <h2>{title}</h2>
        {disabled && <span className={styles.comingSoon}>Coming Soon</span>}
      </div>
      <div className={styles.tasksList}>
        {tasks.map(task => (
          <div 
            key={task.id}
            className={`${styles.taskCard} ${task.status === 'completed' ? styles.completed : ''} ${disabled ? styles.disabled : ''}`}
            onClick={() => !disabled && handleTaskClick(task.id)}
          >
            <div className={styles.taskIcon}>{task.icon}</div>
            <div className={styles.taskInfo}>
              <h3>{task.title}</h3>
              <p className={styles.taskPoints}>+{task.points} pts</p>
            </div>
            <div className={styles.taskStatus}>
              {task.status === 'completed' ? (
                <span className={styles.completedBadge}>✓</span>
              ) : (
                <button className={styles.claimButton} disabled={disabled}>
                  {task.id === 'daily-1' ? 'Check-In' : 'Claim'}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className={styles.tasksSection}>
      <TaskList tasks={dailyTasks} title="Daily Tasks" />
      <TaskList tasks={socialTasks} title="Social Tasks" disabled={true} />
    </div>
  );
};

export default Tasks;
